import { FetchRequest } from '@rails/request.js';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if (document.body.id === 'fp_admin-fp_cabinets') {
    function dateNow() {
      const date = new Date();
      const year = date.getFullYear();
      const month =
        (date.getMonth() + '').length === 1 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const day = (date.getDate() + '').length === 1 ? '0' + date.getDate() : date.getDate();
      const hours = (date.getHours() + '').length === 1 ? '0' + date.getHours() : date.getHours();
      const minutes =
        (date.getMinutes() + '').length === 1 ? '0' + date.getMinutes() : date.getMinutes();
      const seconds =
        (date.getSeconds() + '').length === 1 ? '0' + date.getSeconds() : date.getSeconds();

      return `${year}${month}${day}-${hours}${minutes}${seconds}`;
    }

    function saveJSON(finallyData) {
      console.log('save_json', finallyData);
      const _blob = new Blob([JSON.stringify(finallyData, null, 2)], { type: 'application/json' });
      const _URL = URL.createObjectURL(_blob);
      const a = $$('#save_json_a');
      a.href = _URL;
      a.download = dateNow() + '-cabinets.catalog.json';
      a.click();
    }

    function toHTML(htmlString) {
      const div = document.createElement('div');
      div.innerHTML = htmlString.trim();
      return div.firstChild;
    }

    const $$ = (selector) => {
      return document.querySelector(selector);
    };

    class EditorAPP {
      constructor(options) {
        this.listElement = options.listElement;
        this.thumbElement = options.thumbElement;
        this.editorElement = options.editorElement;

        this.storage = [];
        this.elements = [];

        this.currentTarget = {
          name: null,
          id: null,
          data: null,
        };

        this.activeElementIndex = 0;

        this.dragged_element = {
          start: null,
          over: null,
          dropOn: null,
        };
      }

      resetDraggedData() {
        this.dragged_element = {
          start: null,
          over: null,
          dropOn: null,
        };
      }

      get actualEditorData() {
        const editorDataText = $$('#cabinet_editor').value;
        let asJSON = null;
        if (editorDataText.trim() === '') {
          return null;
        }
        try {
          asJSON = JSON.parse(editorDataText);
        } catch (err) {
          console.warn('Unable to parse cabinet editor data', err);
        }
        return asJSON || null;
      }

      updateActualEditorData(callback) {
        const actualData = this.actualEditorData;
        if (callback && actualData && actualData !== '') {
          const updated = callback(actualData);
          $$('#cabinet_editor').value = JSON.stringify(updated, null, 2);
          this.updateCabinet();
        }
      }

      add_cabinet() {
        const activeElementIndex = this.activeElementIndex || 0;
        const actualData = this.actualEditorData;

        if (!actualData) {
          return;
        }

        let isReadyIn = false;
        for (const cabinet of this.storage) {
          if (cabinet.id === actualData.id) {
            isReadyIn = true;
          }
        }

        if (isReadyIn) {
          console.warn(`cabinet with  [id - ${actualData.id}] is ready in the catalog`);
        } else {
          const nextStorage = [];
          for (let i = 0; i < this.storage.length; i++) {
            if (i === activeElementIndex) {
              nextStorage.push(this.storage[i]); // activeElement
              nextStorage.push(actualData); // activeElement
              this.activeElementIndex = activeElementIndex + 1;
            } else {
              nextStorage.push(this.storage[i]); // activeElement
            }
          }
          this.storage = nextStorage;
          console.log({
            nextStorage,
          });
          this.renderList();
        }
      }

      updateCabinet() {
        const actualData = this.actualEditorData;
        if (!actualData) {
          return;
        }
        let isReadyIn = false;
        console.log({
          actualData,
          storage: this.storage,
        });
        for (let i = 0; i < this.storage.length; i++) {
          const cabinet = this.storage[i];
          if (cabinet.id === actualData.id) {
            isReadyIn = true;
            this.storage[i] = actualData;
            break;
          }
        }
        console.log({
          isReadyIn,
        });
        if (!isReadyIn) {
          console.warn(`cabinet with  [id - ${actualData.id}] is not in the catalog`);
        } else {
          this.renderList();
        }
      }

      remove_cabinet() {
        const actualData = this.actualEditorData;
        if (!actualData) {
          return;
        }
        let successfulyRemoved = false;
        const nextStorage = [];
        for (let i = 0; i < this.storage.length; i++) {
          const cabinet = this.storage[i];
          if (cabinet.id === actualData.id) {
            successfulyRemoved = true;
          } else {
            nextStorage.push(cabinet);
          }
        }
        this.storage = nextStorage;
        if (successfulyRemoved) {
          this.renderList(true);
          console.warn(`cabinet with  [id - ${actualData.id}] removed `);
        }
      }

      move_cabinet_before(sourceElementIndex, targetElementIndex) {
        const sourceCabinet = this.storage[sourceElementIndex];

        const nextData = [];

        for (let i = 0; i < this.storage.length; i++) {
          if (i === sourceElementIndex) {
          } else if (i === targetElementIndex) {
            nextData.push(sourceCabinet);
            nextData.push(this.storage[i]);
          } else {
            nextData.push(this.storage[i]);
          }
        }

        this.storage = nextData;
        this.renderList(true);
      }

      move_cabinet_up() {
        const actualData = this.actualEditorData;
        const id = actualData.id;
        if (!id) {
          console.warn(`cabinet with  [id - ${actualData.id}] is not finded `);
          return;
        }
        let successfulyChanged = false;
        for (let i = 0; i < this.storage.length; i++) {
          const cabinet = this.storage[i];
          if (cabinet.id === actualData.id) {
            if (i === 0) {
              console.warn(
                `element [id - ${actualData.id}] can not be moved up becouse of position 0 `
              );
              return false;
            }
            this.storage[i] = this.storage[i - 1];
            this.storage[i - 1] = cabinet;
            successfulyChanged = true;
            break;
          }
        }
        if (successfulyChanged) {
          this.renderList(true);
          console.warn(`cabinet with  [id - ${actualData.id}] moved up `);
        }
      }

      move_cabinet_down() {
        const actualData = this.actualEditorData;
        const id = actualData.id;
        if (!id) {
          console.warn(`cabinet with  [id - ${actualData.id}] is not finded `);
          return;
        }
        let successfulyChanged = false;
        for (let i = 0; i < this.storage.length; i++) {
          const cabinet = this.storage[i];
          if (cabinet.id === actualData.id) {
            if (i === this.storage.length - 1) {
              console.warn(
                `element [id - ${actualData.id}] can not be moved up becouse of last position`
              );
              return false;
            }
            this.storage[i] = this.storage[i + 1];
            this.storage[i + 1] = cabinet;
            successfulyChanged = true;
            break;
          }
        }
        if (successfulyChanged) {
          this.renderList(true);
          console.warn(`cabinet with  [id - ${actualData.id}] moved up `);
        }
      }

      editElement(cabinetData) {
        this.currentTarget.id = cabinetData.id;
        this.currentTarget.name = cabinetData.name;
        this.currentTarget.data = cabinetData;
        if (cabinetData.thumb !== '') {
          $$('#cabinet_thumb').src = cabinetData.thumb;
        }
        $$('#cabinet_editor').value = JSON.stringify(cabinetData, null, 2);
      }

      renderListElement(cabinetData, index) {
        let nextElement = null;

        const { size_initial: sizeInitial } = cabinetData;

        let addonString = '';

        // for cabinets
        if (sizeInitial) {
          const sz = sizeInitial;
          addonString = sizeInitial
            ? `<br><br><b><small>${sz.W} x ${sz.H} x ${sz.D}</small></b>`
            : '';
        }

        const activeElementClass = this.activeElementIndex === index ? 'is-active' : '';

        const listElementClasses = [
          'cabinet_list_element',
          'relative float-left block w-32 h-32 m-[5px] p-0.5',
          'border border-[#333] rounded-[5px] bg-[antiquewhite] font-[monospace] cursor-pointer',
          '[&.is-active]:shadow-[-2px_-2px_2px_#57affc,2px_2px_2px_#57affc]',
          '[&.drag-over]:shadow-[-4px_0_4px_#ff5500]',
        ].join(' ');

        nextElement = toHTML(`
                <div class="${listElementClasses} ${activeElementClass}">
                    <span class="block absolute top-[5px] left-[5px] z-[15]">${cabinetData.id}</span>
                    <span class="block absolute bottom-[5px] left-[5px] z-[15]">${cabinetData.name} ${addonString}</span>
                    <img class="w-full h-full" src="${cabinetData.thumb}">
                </div>
            `);

        nextElement.dataset.index = index;

        nextElement.addEventListener('click', () => {
          const previousActiveElement = $$(
            `.cabinet_list_element[data-index="${this.activeElementIndex}"]`
          );

          // There won't be a previous active element in the list rendered if the
          // search made returns only a single element, so we need this condition.
          if (previousActiveElement) {
            previousActiveElement.classList.remove('is-active');
          }

          nextElement.classList.add('is-active');
          this.activeElementIndex = index;
          this.editElement(cabinetData);
        });

        nextElement.addEventListener('dragstart', () => {
          this.dragged_element.start = nextElement;
        });

        nextElement.addEventListener('drop', () => {
          const start = this.dragged_element.start;
          const over = this.dragged_element.over;

          if (start && over) {
            if (start.dataset.index !== over.dataset.index) {
              this.move_cabinet_before(start.dataset.index, over.dataset.index);
            }
          }

          this.dragged_element.over.classList.remove('drag-over');
          this.resetDraggedData();
        });

        nextElement.addEventListener('dragleave', () => {
          if (this.dragged_element.over) {
            this.dragged_element.over.classList.remove('drag-over');
            this.dragged_element.over = null;
          }
        });

        nextElement.addEventListener('dragover', (event) => {
          event.preventDefault();
          if (this.dragged_element.over !== nextElement) {
            this.dragged_element.over = nextElement;
            this.dragged_element.over.classList.add('drag-over');
          }
        });

        return nextElement;
      }

      renderList(presetFirstElement) {
        this.listElement.innerHTML = '';
        const actualData = this.actualEditorData;
        const id = actualData ? actualData.id : null;
        let actualDataPosition = -1;
        const filterQuery = $$('#cabinets_data_filter').value;

        for (let i = 0; i < this.storage.length; i++) {
          const nextElement = this.storage[i];
          if (nextElement.id === id) {
            actualDataPosition = i;
          }
        }

        if (presetFirstElement && this.storage.length > 0) {
          this.activeElementIndex = actualDataPosition === -1 ? 0 : actualDataPosition;
        }

        for (let i = 0; i < this.storage.length; i++) {
          const nextElement = this.storage[i];
          if (filterQuery !== '' && !JSON.stringify(nextElement).includes(filterQuery)) {
            continue;
          }
          const htmlEl = this.renderListElement(nextElement, i);
          if (htmlEl) {
            this.listElement.appendChild(htmlEl);
          }
        }
        if (presetFirstElement && this.storage.length > 0) {
          this.editElement(this.storage[this.activeElementIndex]);
        }
      }

      replaceStorage(jsonCabinetsData) {
        console.log(jsonCabinetsData);
        this.storage = jsonCabinetsData;
        this.renderList(true);
      }
    }

    const APP = new EditorAPP({
      listElement: $$('.cabinets_list'),
      thumbElement: $$('#cabinet_thumb'),
      editorElement: $$('.cabinet_editor'),
    });

    window.onload = () => {
      const readFileJSON = (file) => {
        return new Promise((resolve, reject) => {
          if (file) {
            const fs = new FileReader();
            fs.onload = () => {
              let jsonData = null;
              try {
                jsonData = JSON.parse(fs.result);
              } catch (err) {
                console.error(err);
              }
              if (jsonData) {
                resolve(jsonData);
              }
            };
            fs.readAsText(file);
          } else {
            reject(new Error('no file for read'));
          }
        });
      };

      $$('#cabinets_data_filter').addEventListener('input', () => {
        APP.renderList();
      });

      $$('#uploadCatalog').addEventListener('change', async function () {
        const file = this.files[0];
        if (file) {
          const jsonData = await readFileJSON(file);
          APP.replaceStorage(jsonData);
        }
      });

      $$('#download_json').addEventListener('click', async function () {
        saveJSON(APP.storage);
      });

      $$('#save_changes').addEventListener('click', async function () {
        const updateStatus = document.querySelector('[data-update-status]');
        const fpCabinetId = document.querySelector('[data-fp-cabinet-id]').dataset.fpCabinetId;
        const request = new FetchRequest('patch', `/u/fp_admin/fp_cabinets/${fpCabinetId}`, {
          body: JSON.stringify({ json_editor: { data: APP.storage } }),
        });
        const response = await request.perform();

        if (response.ok) {
          updateStatus.innerText = 'Data updated successfully';
        } else {
          const body = await response.json;

          updateStatus.innerText = body.errors.join(', ');
        }
      });

      $$('#update_cabinet').addEventListener('click', async function () {
        APP.updateCabinet();
      });

      $$('#add_cabinet').addEventListener('click', async function () {
        APP.add_cabinet();
      });

      $$('#remove_cabinet').addEventListener('click', async function () {
        APP.remove_cabinet();
      });

      $$('#move_cabinet_up').addEventListener('click', async function () {
        APP.move_cabinet_up();
      });

      $$('#move_cabinet_down').addEventListener('click', async function () {
        APP.move_cabinet_down();
      });

      $$('#update_thumb_input').addEventListener('change', async function () {
        const file = this.files[0];
        if (file) {
          const thumbPath = `https://s3.us-east-1.amazonaws.com/df.fp-kitchen-models/Cabinets+images/${file.name.replaceAll(
            ' ',
            '+'
          )}`;
          APP.updateActualEditorData((currentData) => {
            if (currentData.thumb) {
              currentData.thumb = thumbPath;
            }
            return currentData;
          });
          this.value = null;
        }
      });

      const fpCabinetsEditor = document.querySelector('[data-fp-cabinet-editor="true"]');
      const fpCabinets = fpCabinetsEditor.dataset.fpCabinets;

      APP.replaceStorage(JSON.parse(fpCabinets));
    };
  }
});
